import {
  Community,
  CommunityDisclaimer,
  ContentNotifications,
  Language,
  NotificationPreferencesInput,
  PreferencesInput,
} from '@/graphql/types';
import { createContext, useContext } from 'react';

export type UserPreferencesContextType = {
  language: Language;
  community: Community;
  viewWholeCommunityFlyers: CommunityDisclaimer;
  notificationPreferences: ContentNotifications;
  updateUserPreferences: (input: PreferencesInput) => Promise<Boolean>;
  updateNotificationPreferences: (input: NotificationPreferencesInput) => Promise<Boolean>;
  defaultLanguage: string;
  googleApiKey: string;
  loading: boolean;
  isEnglishLanguage: boolean;
};

const UserPreferencesContext = createContext<UserPreferencesContextType>({
  viewWholeCommunityFlyers: {
    version: null,
    acceptedAt: null,
  },
  language: {
    name: 'English',
    code: 'en',
  },
  community: {
    address: '',
    distance: 0,
    localArea: '',
    location: {
      lat: 0,
      lng: 0,
    },
    metricType: '',
    placeId: '',
    isSaved: false,
  },
  notificationPreferences: {
    newFlyer: false,
    upcomingSavedSearch: false,
    savedSearch: false,
  },
  updateUserPreferences: async (input: PreferencesInput) => true,
  updateNotificationPreferences: async (input: NotificationPreferencesInput) => true,
  defaultLanguage: 'en',
  googleApiKey: '',
  loading: false,
  isEnglishLanguage: true,
});

export const useLanguageContext = () => useContext(UserPreferencesContext);

export default UserPreferencesContext;
